module.exports = __webpack_public_path__ + "img/10-s.a9c661c9.png";